import './Stats.css';
import { IconShield, IconClock, IconMap, IconTracking } from './Icons';

const PILLARS = [
  { icon: IconShield, label: 'Segurança' },
  { icon: IconClock, label: 'Pontualidade' },
  { icon: IconMap, label: 'Cobertura Nacional' },
  { icon: IconTracking, label: 'Rastreamento em Tempo Real' },
];

function Stats() {
  return (
    <section className="stats-section" aria-label="Diferenciais operacionais">
      <div className="container">
        <div className="row g-4 text-center">
          {PILLARS.map(({ icon: Icon, label }) => (
            <div key={label} className="col-6 col-lg-3">
              <div className="stat-item">
                <div className="icon-circle mx-auto">
                  <Icon />
                </div>
                <span className="stat-label">{label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
